import { render, staticRenderFns } from "./OrganisationSelect.vue?vue&type=template&id=29650602&scoped=true"
import script from "./OrganisationSelect.vue?vue&type=script&lang=ts"
export * from "./OrganisationSelect.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "29650602",
  null
  ,true
)

export default component.exports